import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { fmtMoeda, fmt } from '@/lib/utils/formatters';
import { useApuracaoSN } from '@/contexts';

export function AnexoAliquotaCard() {
  const { dados, aguardandoPgdas } = useApuracaoSN();

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Anexo e Alíquota
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {aguardandoPgdas && (
          <p className="text-xs font-medium text-amber-600">
            Anexo e faixa dependem do RBT12 — aguardando leitura do PGDAS.
          </p>
        )}
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Anexo Aplicável</span>
          <Badge className="bg-foreground text-background hover:bg-foreground/90">
            {dados.anexo}
          </Badge>
        </div>

        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Alíquota Nominal</span>
            <span className="font-medium">{fmt(dados.aliquotaNominal)}%</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Parcela a Deduzir</span>
            <span className="font-medium">{fmtMoeda(dados.parcelaADeduzir)}</span>
          </div>
        </div>

        <div className="pt-2 border-t">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Alíquota Efetiva</span>
            <span className="text-2xl font-bold">{fmt(dados.aliquotaEfetiva)}%</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
